import { render, staticRenderFns } from "./StackSvg.vue?vue&type=template&id=c930985a"
import script from "./StackSvg.vue?vue&type=script&lang=js"
export * from "./StackSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports